export const globalFeatureKey = 'global';
